import { useState } from "react";
import api from "../../../services/api";
import { BackButton } from "../../../components/button/back-button";
import { useToast } from "../../../contexts/toast/toast-context";
import { getApiErrorMessage } from "../../../utils";
import { LoadingButton } from "../../../components/button/loading-button";

export default function ChangePassword() {
  const { error, success } = useToast();

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (isSubmitting) return;

    if (!currentPassword || !newPassword || !confirmPassword) {
      error("Preencha todos os campos");
      return;
    }

    if (newPassword.length < 8) {
      error("A nova senha deve ter pelo menos 8 caracteres");
      return;
    }

    if (newPassword !== confirmPassword) {
      error("As senhas não coincidem");
      return;
    }

    try {
      setIsSubmitting(true);
      await api.post("/auth/password-change", { currentPassword, newPassword });

      success(`Senha alterada com sucesso!`);
    } catch (err) {
      const apiMessage = getApiErrorMessage(err);
      error(apiMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="app-page">
      <BackButton />
      <h1 className="app-page-title mb-6">Alterar senha</h1>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label className="form-label">Senha Atual</label>
          <input
            type="password"
            className="form-input"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
          />
        </div>

        <div>
          <label className="form-label">Nova senha</label>

          <input
            type="password"
            className="form-input"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
        </div>

        <div>
          <label className="form-label">Confirmar nova senha</label>
          <input
            type="password"
            className="form-input"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
        </div>

        <LoadingButton
          type="submit"
          className="btn btn-neutral cursor-pointer"
          isLoading={isSubmitting}
          loadingLabel="Salvando"
        >
          Alterar Senha
        </LoadingButton>
      </form>
    </div>
  );
}
